import ReactApexChart from "react-apexcharts";
import { format } from 'date-fns';

const MonthlyExpensesChart = ({ appointments, pathologyBills, medicineBills }) => {
  // 1. Prepare data structure for the last 12 months
  const months = Array.from({ length: 12 }).map((_, i) => {
    const d = new Date();
    d.setMonth(d.getMonth() - i);
    return format(d, 'MMM yyyy');
  }).reverse();

  const appointmentSpending = Array(12).fill(0);
  const pathologySpending = Array(12).fill(0);
  const pharmacySpending = Array(12).fill(0);

  // 2. Process each data type and add expenses to the correct month
  appointments.forEach(appt => {
    const monthKey = format(new Date(appt.createdAt), 'MMM yyyy');
    const index = months.indexOf(monthKey);
    if (index !== -1) appointmentSpending[index] += appt.consultationFee || 0;
  });

  pathologyBills.forEach(bill => {
    const monthKey = format(new Date(bill.createdAt), 'MMM yyyy');
    const index = months.indexOf(monthKey);
    if (index !== -1) pathologySpending[index] += bill.netAmount || 0;
  });

  medicineBills.forEach(bill => {
    const monthKey = format(new Date(bill.createdAt), 'MMM yyyy');
    const index = months.indexOf(monthKey);
    if (index !== -1) pharmacySpending[index] += bill.netAmount || 0;
  });

  // 3. Calculate the total spending line
  const totalSpending = months.map((_, i) =>
    appointmentSpending[i] + pathologySpending[i] + pharmacySpending[i]
  );
  
  const chartState = {
    series: [
      { name: 'Appointments', type: 'column', data: appointmentSpending },
      { name: 'Pathology', type: 'column', data: pathologySpending },
      { name: 'Pharmacy', type: 'column', data: pharmacySpending },
      { name: 'Total', type: 'line', data: totalSpending }
    ],
    options: {
      chart: { type: 'line', height: 400, toolbar: { show: false } },
      plotOptions: { bar: { horizontal: false, borderRadius: 4, columnWidth: '70%', stacked: true } },
      dataLabels: { enabled: false },
      stroke: { width: [0, 0, 0, 0, 3], dashArray: [0,0,0,0, 3] },
      xaxis: { categories: months, labels: { style: { colors: "#9CA3AF" } } },
      yaxis: {
        labels: {
          style: { colors: "#9CA3AF" },
          formatter: (val) => `৳${val.toLocaleString()}`
        }
      },
      tooltip: { y: { formatter: (val) => `৳${val.toFixed(2)}` } },
      legend: { position: 'top', horizontalAlign: 'right' },
      colors: ["#3B82F6", "#10B981", "#F59E0B", "#8B5CF6", "#EF4444"],
    },
  };

  return (
    <div>
      <ReactApexChart
        options={chartState.options}
        series={chartState.series}
        type="line"
        height={400}
      />
    </div>
  );
};

export default MonthlyExpensesChart;